// extracted by mini-css-extract-plugin
export default {"blockwrapper":"QL","header":"RL","name":"SL","columns":"TL","imagewrapper":"UL","addinfo":"VL","description":"WL","price":"XL","old":"YL","new":"ZL","desc_d":"aM","infoblock":"bM","desc_m":"cM"};
    if(module.hot) {
      // 1713969935188
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  